import React from "react";

import * as R from "ramda";

import Carousel from "nuka-carousel";

import { ArrowInCircle } from "src/icons";

import { Button, Flex } from "src/components/base";

import { themeColor } from "src/styles";

import PhotoWithCaption from "../PhotoWithCaption";

const AUTOPLAY_INTERVAL = 7500; // 15 seconds

const ArrowLink = ({ onClick, direction, currentImage, title, theme }) => {
  const currentTheme = currentImage.theme || theme;
  const color = themeColor(currentTheme);

  return (
    <Button
      onClick={onClick}
      p={2}
      bg="transparent"
      borderWidth={0}
      style={{
        cursor: "pointer",
      }}
      title={title}
    >
      <ArrowInCircle size={40} color={color} direction={direction} />
    </Button>
  );
};

const PagingDot = ({ index, active, onClick, size = active ? 15 : 10 }) => (
  <Button
    bg={active ? "white" : "whiteTransparent"}
    borderRadius={size / 2}
    borderWidth={0}
    style={{
      cursor: "pointer",
    }}
    height={size}
    width={size}
    boxShadow={2}
    p={0}
    mx={1}
    onClick={onClick}
    title={active ? `Viewing slide ${index + 1}` : `View slide ${index + 1}`}
  />
);

const PagingDots = ({ currentSlide, slideCount, goToSlide }) => (
  <Flex align="center" justify="center" my={[1, 1, 2, 3]} mx={[2, 1, 2, 3]}>
    {R.times(
      index => (
        <PagingDot
          active={currentSlide === index}
          onClick={() => goToSlide(index)}
          index={index}
          key={index}
        />
      ),
      slideCount
    )}
  </Flex>
);

export default ({ images, ...props }) =>
  images.length === 1 ? (
    <PhotoWithCaption {...props} key={images[0].url} content={images[0]} />
  ) : (
    <Carousel
      autoplay={true}
      autoplayInterval={AUTOPLAY_INTERVAL}
      wrapAround={true}
      renderCenterLeftControls={({ previousSlide, currentSlide }) => (
        <ArrowLink
          onClick={previousSlide}
          currentImage={images[currentSlide]}
          theme={props.theme}
          direction="left"
          title="View previous slide"
        />
      )}
      renderCenterRightControls={({ nextSlide, currentSlide }) => (
        <ArrowLink
          onClick={nextSlide}
          currentImage={images[currentSlide]}
          theme={props.theme}
          direction="right"
          title="View next slide"
        />
      )}
      renderBottomCenterControls={null}
      renderTopRightControls={props => <PagingDots {...props} />}
    >
      {images.map(image => (
        <PhotoWithCaption {...props} key={image.id} content={image} />
      ))}
    </Carousel>
  );



// WEBPACK FOOTER //
// ./src/components/HeaderSlider/HeaderSlider.js